import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import style from './IndexFactorManagementTable.module.scss';
import InitTable, { Query } from '../Table/Table';
import Loader from '../Loader/Loader';
import { getIndexTable, getErrorMessage } from '../../services';
import { IndexTableFactor, IToastMessage } from '../../interface';
import _ from 'lodash';

const { Table, Column } = InitTable<IndexTableFactor>();

interface Props {
  className?: string;
  indexTableId?: number | null;
}

function IndexFactorManagementTable({
  className,
  indexTableId,
}: Props) {
  const [fetchingFactors, setFetchingFactors] = useState(false);
  const [indexFactors, setIndexFactors] = useState<IndexTableFactor[]>([]);
  const [toastMessage, setToastMessage] = useState<IToastMessage>();
  const [tableQuery, setTableQuery] = useState<Query>({});

  const showErrorMessage = (message: string) => {
    window.scrollTo(0, 0);
    setToastMessage({
      message,
      visible: true,
      type: 'error',
    });
  }
  
  useEffect(() => {
    if (indexTableId) {
      setFetchingFactors(true);
      getIndexTable(indexTableId)
        .then((res) => {
          if (res.data) {
            setIndexFactors(res.data.factors);
            setFetchingFactors(false);
          }
        })
        .catch((e) => {
          showErrorMessage(getErrorMessage(e));
          setFetchingFactors(false);
        })
    }
  }, [indexTableId]);

  const factorsPage = useMemo(() => {
    const orderedFactors = _.orderBy(
      indexFactors,
      _.last(_.keys(tableQuery?.order)),
      _.last(_.values(tableQuery?.order)),
    )
    return _.nth(
      _.chunk(
        orderedFactors,
        tableQuery?.pagination?.pageSize,
      ),
      (tableQuery?.pagination?.page as number) - 1,
    ) as IndexTableFactor[];
  }, [
    indexFactors,
    tableQuery?.pagination
  ]);

  return (
    <div className={
      classNames(
        className,
        style['main-content'],
        'IndexFactorManagement d-flex flex-column'
      )
    }>
      <Table
        id='IndexFactorsEditTable'
        rows={factorsPage}
        paginate
        totalRows={indexFactors?.length}
        loading={false}
        onQueryChanged={query => setTableQuery(query)}
      >
        <Column
          label='Age'
          prop='age'
        />

        <Column
          label='Value'
          prop='value'
        />
      </Table>

      <Loader isOpen={
        fetchingFactors
      } />
    </div>
  );
}

export default IndexFactorManagementTable;